import { Grid } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import Button, { Colors } from "Components/Form/Button";
import { FiEdit } from "react-icons/fi";

export const ExpenseManagementWrapper = styled(Grid)({});

export const GridWrapper = styled(Grid)({
  width: "100%",
});

export const IconClose = styled("div")({
  cursor: "pointer",
});

export const IconEdit = styled(FiEdit)({
  cursor: "pointer",
});

export const WrapperSelect = styled("div")({
  width: 180,
});

export const TooltipWrapper = styled("div")({
  position: "relative",
  "&:hover": {
    ".tooltip-div": {
      display: "block",
    },
  },
});

export const TooltipDiv = styled("div")(() => ({
  "&.tooltip-div": {
    display: "none",
  },
  position: "absolute",
  background: colors.white,
  padding: 16,
  borderRadius: 12,
  top: "-80px",
  right: 0,
  boxShadow: "0px 1px 3px 1px rgba(71, 84, 103, 0.15), 0px 1px 2px 0px rgba(71, 84, 103, 0.30)",
  "& > div": {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    "& div": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      "& span": {
        color: colors.gray600,
        fontFamily: "Manrope",
        fontSize: 12,
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: 0.4,
        "&:nth-of-type(2)": {
          fontWeight: 600,
        },
      },
    },
  },
}));

export const CostBox = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 4,
  padding: "8px 12px",
  border: `1px solid ${colors.gray300}`,
  borderRadius: 8,
  cursor: "pointer",
});

export const StyledButton = styled(Button)({
  width: "100% !important",
});

export const WrapperButtons = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
});
